<template>
  <div>
    <van-form>
      <van-field
        input-align="right"
        v-model="formData.SumAmount"
        label="产品类别"
        placeholder="请选择"
      />
      <van-field
        input-align="right"
        v-model="formData.SumAmount"
        label="产品子类"
        placeholder="请选择"
      />
      <van-field
        input-align="right"
        v-model="formData.SumAmount"
        label="产品"
        placeholder="请选择"
      />
      <van-field
        input-align="right"
        v-model="formData.SumAmount"
        label="业务单元"
        placeholder="请选择"
      />
      <van-field
        input-align="right"
        v-model="formData.SumAmount"
        label="业务子单元"
        placeholder="请选择"
      />
    </van-form>
    <van-row class="mt10" :gutter="5">
      <van-col :span="12">
        <van-button block plain type="primary">查询</van-button>
      </van-col>
      <van-col :span="12">
        <van-button block type="primary">生产产品</van-button>
      </van-col>
      <van-col :span="12"></van-col>
    </van-row>
  </div>
</template>

<script>
  export default {
    name: "production",
    data() {
      return {
        formData: {}
      }
    },
    methods: {
      Materialpurch() {
        this.$router.push({path: '/mate'})
      },
      pro() {
        this.$router.push({path: '/pro'})
      },
      reg() {
        this.$router.push({path: '/reg'})
      },
      Material() {
        this.$router.push({path: '/material'})
      },
      Mate() {
        this.$router.push({path: '/materialp'})
      },
      Asset() {
        this.$router.push({path: '/Asset'})
      },
      Materia() {
        this.$router.push({path: '/Materia'})
      },
      back() {
        this.$router.push('/home')
      },
    }
  }
</script>
